import * as yup from 'yup';
import { FieldErrors, FieldValues } from 'react-hook-form';
import { Sections } from './enums';
import { convertCamelCaseToLabel } from '../lib/utils';

export const generateValidations = (props: FieldProps | MaterialUiFieldProps) => {
	const validations = {} as any;
	if (props.required === true) validations.required = 'Required';
	if (props.minLength)
		validations.minLength = { value: props.minLength, message: `Minimum length is ${props.minLength}` };
	if (props.maxLength)
		validations.maxLength = { value: props.maxLength, message: `Maximum length is ${props.maxLength}` };
	if (props.min) validations.min = { value: props.min, message: 'The number is too small' };
	if (props.max) validations.max = { value: props.max, message: 'The number is too large' };
	if (props.pattern)
		validations.pattern = {
			value: new RegExp(props.pattern),
			message: props.patternErrorMessage ?? 'Invalid value'
		};
	if (props.validate) validations.validate = props.validate;

	return validations;
};

yup.setLocale({
	mixed: {
		default: ({ path }) => `${convertCamelCaseToLabel(path)} is invalid`,
		required: ({ path }) => `${convertCamelCaseToLabel(path)} is a required field`
	},
	string: {
		max: ({ path, max }) => `${convertCamelCaseToLabel(path)} cannot be longer than ${max} characters`,
		email: ({ path }) => `${convertCamelCaseToLabel(path)} must be a valid email address`
	},
	date: {
		max: ({ path }) => `${convertCamelCaseToLabel(path)} is invalid`
	}
});

export interface FieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	errors?: FieldErrors<FieldValues>;
	control?: any;
	patternErrorMessage?: string;
	section?: Sections;
	data?: any;
	className?: string;
	validate?: any;
	defaultFormField?: boolean;
	startAdornment?: React.ReactNode;
	endAdornment?: React.ReactNode;
}

export interface MaterialUiFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	error?: boolean;
	helperText?: string;
	patternErrorMessage?: string;
	validate?: any;
	defaultValue?: any;
	startAdornment?: React.ReactNode;
	endAdornment?: React.ReactNode;
	multiline?: boolean;
	minRows?: number;
	displayInLineLabel?: boolean;
}
